
<script>
 import PainelEditaBotao from "./painel_edita_botao.svelte";
 import {createEventDispatcher } from 'svelte';
 const dispatch = createEventDispatcher();
let abrirPainel=false;
export let posicao;
export let id_botao;
export let referencia;
export let link;
export let botao;
export let corBotao="#d1d1d1"
export let corLetraBotao="#212529";
export let sombraBotao1=0;
export	 let sombraBotao2=0;
export	 let sombraBotao3=0;
export	 let sombraBotao4=0;
export	 let corSombraBotao="#000000";
	 
export	 let espacamentoBotaoSuperior=0;
export	 let espacamentoBotaoInferior=0;
export let fonteBotao;
export let tamanhoLetraBotao=35;
let fonte;
$:sombraBotao11=sombraBotao1+"px";
$:sombraBotao12=sombraBotao2+"px";
$:sombraBotao13=sombraBotao3+"px";
$:sombraBotao14=sombraBotao4+"px";
$:espacamentoBotaoSuperior1=espacamentoBotaoSuperior+"px";
$:espacamentoBotaoInferior1=espacamentoBotaoInferior+"px";
$:tamanhoLetraBotao1=tamanhoLetraBotao+"px";
$:if (fonteBotao!=""){
     
     
     fonte="font-family:"+fonteBotao;
      console.log(fonte);
   }else{
     fonte="";
   }
function  AbrirEdicao(e) {
  e.preventDefault;
  abrirPainel=!abrirPainel;

}
function  EditandoBotao(e) {
  e.preventDefault();
  dispatch("EditandoBotao",e.detail);
  console.log(e.detail.itemBotao);
  console.log(e);

  abrirPainel=!abrirPainel;


}
function  Apagar(e) {
  e.preventDefault();
   dispatch("ApagarBotao");
   abrirPainel=!abrirPainel;
  console.log("ApagarBotao");
}
function  Sobe(e) {
  e.preventDefault();
   dispatch("SobeBotao");
   
  console.log("SobeBotao");
}
function  Desce(e) {
  e.preventDefault();
   dispatch("DesceBotao");
   
  console.log("DesceBotao");
}
</script>

<style>

.largura-fixa {
    width:300px;
  }


</style>

 <a class="text-center" href=" " name="{"link"+referencia}" value="{link}"  style=""
  ><button on:click|preventDefault={AbrirEdicao} name="{"botao"+referencia}" class="btn btn-danger  largura-fixa" style="color:{corLetraBotao};
   background-color:{corBotao} ; border-color:{corBotao}; 
 box-shadow:{sombraBotao11} {sombraBotao12} {sombraBotao13} {sombraBotao14} {corSombraBotao};
 margin-top:{espacamentoBotaoSuperior1};
  margin-bottom:{espacamentoBotaoInferior1}; {fonte};
  font-size:{tamanhoLetraBotao1}
 
 " value="{botao}"><strong>{botao}</strong></button></a><p>   </p>  

 {#if abrirPainel}

<PainelEditaBotao on:Cancelar={()=>abrirPainel=false  } {botao}
{link}
{id_botao}
{posicao}
{corLetraBotao} {corBotao}
{sombraBotao1}
{sombraBotao2}
{sombraBotao3}
{sombraBotao4}
{corSombraBotao}
{espacamentoBotaoInferior}
{espacamentoBotaoSuperior}
on:Edicao={EditandoBotao}
on:Apagar={Apagar}
on:Sobe={Sobe}
on:Desce={Desce}
/>
 {/if}